export const whatsappTemplatePayload = (
  template,
  headerVariables,
  bodyVariables,
  sampleValues
) => {
  const components = [];

  // BODY
  const body = {
    type: 'BODY',
  };

  // Add authentication-specific fields
  if (template.category === 'AUTHENTICATION') {
    if (template.addSecurityRecommendation) {
      body.add_security_recommendation = true;
    }
  } else {
    body.text = template.body;
  }

  if (bodyVariables.length > 0) {
    body.example = {
      body_text: [bodyVariables.map(v => sampleValues.bodyValues[v] || '')],
    };
  }
  components.push(body);

  // CAROUSEL SPECIFIC
  if (
    template.format === 'CAROUSEL' &&
    template.cards &&
    template.cards.length > 0
  ) {
    const carousel = {
      type: 'CAROUSEL',
      cards: template.cards.map(card => {
        const cardComponents = [];

        // Card Header (Required for Carousel)
        if (['IMAGE', 'VIDEO'].includes(card.headerType)) {
          cardComponents.push({
            type: 'HEADER',
            format: card.headerType,
            example: {
              header_url: [
                card.mediaUrl ||
                  'https://chatwoot-assets.s3.amazonaws.com/placeholder.png',
              ],
            },
          });
        }

        // Card Body
        cardComponents.push({
          type: 'BODY',
          text: card.body,
        });

        // Card Buttons
        if (card.buttons.length > 0) {
          const buttons = {
            type: 'BUTTONS',
            buttons: card.buttons.map(b => ({
              type: b.type,
              text: b.text,
              url: b.type === 'URL' ? b.url : undefined,
              phone_number:
                b.type === 'PHONE_NUMBER' ? b.phone_number : undefined,
            })),
          };
          cardComponents.push(buttons);
        }

        return {
          components: cardComponents,
        };
      }),
    };
    components.push(carousel);
  }

  // STANDARD SPECIFIC
  else {
    // HEADER (Standard only)
    if (template.header !== 'NONE') {
      const header = {
        type: 'HEADER',
        format: template.header,
      };

      if (template.header === 'TEXT') {
        header.text = template.headerText;
        if (headerVariables.length > 0) {
          header.example = {
            header_text: [sampleValues.headerValues[1] || ''],
          };
        }
      } else if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(template.header)) {
        if (template.headerMediaHandle) {
          header.example = { header_handle: [template.headerMediaHandle] };
        } else {
          header.example = {
            header_url: [
              template.headerMediaUrl ||
                'https://chatwoot-assets.s3.amazonaws.com/placeholder.png',
            ],
          };
        }
      }

      // Prepend header for standard
      components.unshift(header);
    }

    // FOOTER
    let footer = {
      type: 'FOOTER',
    };
    if (template.footer) {
      if (
        template.category === 'AUTHENTICATION' &&
        template.addExpirationTime &&
        template.expirationTimeMinutes
      ) {
        footer.code_expiration_minutes = parseInt(
          template.expirationTimeMinutes,
          10
        );
      } else {
        footer.text = template.footer;
      }
      components.push(footer);
    }

    // BUTTONS
    if (template.category === 'AUTHENTICATION' || template.buttons.length > 0) {
      if (template.category === 'AUTHENTICATION') {
        const authButton = {
          type: 'otp',
          otp_type: template.authCodeDeliveryMethod.toLowerCase(),
          text: 'Copy Code',
        };

        if (
          template.authCodeDeliveryMethod === 'ONE_TAP' ||
          template.authCodeDeliveryMethod === 'ZERO_TAP'
        ) {
          authButton.autofill_text = 'Autofill';
          authButton.package_name = template.packageName;
          authButton.signature_hash = template.signatureHash;
        }

        if (template.authCodeDeliveryMethod === 'ZERO_TAP') {
          authButton.zero_tap_terms_accepted = true;
        }

        components.push({
          type: 'buttons',
          buttons: [authButton],
        });
      } else {
        const buttons = {
          type: 'BUTTONS',
          buttons: template.buttons.map(b => ({
            type: b.type,
            text: b.text,
            url: b.url || undefined,
            phone_number: b.phone_number || b.phoneNumber || undefined,
            example: b.example || undefined,
          })),
        };
        components.push(buttons);
      }
    }
  }

  return {
    name: template.name,
    language: template.language,
    category: template.category,
    components,
  };
};
